import { LightTheme, createTheme } from "baseui"

//   customise the theme with the code below

// const primitives = {
//   primaryA: '#F127E4',
// };

// const overrides = {
//   colors: {
//     buttonPrimaryFill: '#F127E4',
//   },
// };

// export const customTheme = createTheme(primitives, overrides);

// the default light theme
export const customTheme = LightTheme
